import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { MessageSquareText } from "lucide-react";

/**
 * Fetches and shows feedback for a booking on demand. Backend already
 * restricts GET /bookings/{id}/feedback to the concerned client, the
 * concerned counselor, or admin — this component just renders the result.
 */
export default function FeedbackViewer({ bookingId, testIdPrefix = "feedback" }) {
  const [open, setOpen] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const toggle = async () => {
    if (open) { setOpen(false); return; }
    setOpen(true);
    if (feedback) return;
    setBusy(true); setErr("");
    try {
      const { data } = await api.get(`/bookings/${bookingId}/feedback`);
      setFeedback(data);
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setBusy(false); }
  };

  return (
    <div>
      <button type="button" data-testid={`${testIdPrefix}-toggle-${bookingId}`} onClick={toggle}
        className="text-xs underline inline-flex items-center gap-1" style={{ color: "var(--brand)" }}>
        <MessageSquareText className="w-3.5 h-3.5" /> {open ? "Hide feedback" : "View feedback"}
      </button>
      {open && (
        <div data-testid={`${testIdPrefix}-body-${bookingId}`} className="mt-2 text-sm rounded-xl p-3"
          style={{ background: "rgba(91,117,83,0.08)" }}>
          {busy && <span style={{ color: "var(--text-secondary)" }}>Loading…</span>}
          {err && <span style={{ color: "var(--accent)" }}>{err}</span>}
          {feedback && <p className="italic">&ldquo;{feedback.text}&rdquo;</p>}
        </div>
      )}
    </div>
  );
}
